<div class="problem-msg-container white-box pdf" *ngIf="messages || errorMessage">
  <ul *ngIf="messages">
    <li *ngFor="let message of messages">{{ message }}</li>
  </ul>
  <div *ngIf="errorMessage" data-html2canvas-ignore>{{ errorMessage }}</div>
</div>
